// extracted by mini-css-extract-plugin
export default {"title":"SeatingPlanScreen_title__julcS","mainDiv":"SeatingPlanScreen_mainDiv__ysWkD"};